import type { Dayjs } from 'app/utils/dayjs';
import type { PackSelectionValue } from 'app/utils/packSelection';

export enum VoucherReasonType {
  STAYCATION_ERROR = "Staycation's error",
  HOTEL_ERROR = 'Hotel error',
  BAD_FEEDBACK = 'Bad feedback',
  CLIENTS_COMPLAINTS = 'Clients complaints',
  OTHER = 'Other',
}

export type Voucher = {
  code: string;
  initialValue: number;
  remainingValue: number;
  expirationDate: string;
  createdAt: string;
  createdBy: string;
  reasonType: VoucherReasonType;
  comment?: string;
};

export type VoucherType = 'voucher' | 'incentive' | 'internal';

export type ValueType = 'FIX' | 'PERCENT';

export type VoucherForm = {
  code?: string;
  value: number;
  beneficiary: string;
  countryId: number;
  expirationDate: Dayjs;
  startDate?: Dayjs;
  bookingId?: number;
  reasonType: string;
  comment?: string;
  userId: number;
  giftCardType: VoucherType;
  infinite: boolean;
  valueType: ValueType;
  minAmount?: number;
  maxUse?: number;
  onlyFirstBooking?: boolean;
  restrictedPackageIds?: number[];
  restrictedPackIds?: number[];
  restrictedToCountry: boolean;
};

export type VoucherFormValues = VoucherForm & {
  specificPackageOnly?: boolean;
  restrictedPacks?: PackSelectionValue[];
};
